
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire13c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire13c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("68bIR", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $476c954992d821a6$export$6503ec6e8aabbaf; }, function (v) { return $476c954992d821a6$export$6503ec6e8aabbaf = v; });
var $476c954992d821a6$export$6503ec6e8aabbaf;
var $476c954992d821a6$export$f7ad0328861e2f03;
"use strict";
var $476c954992d821a6$var$mapping = new Map();
function $476c954992d821a6$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$476c954992d821a6$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $476c954992d821a6$var$resolve(id) {
    var resolved = $476c954992d821a6$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$476c954992d821a6$export$6503ec6e8aabbaf = $476c954992d821a6$var$register;
$476c954992d821a6$export$f7ad0328861e2f03 = $476c954992d821a6$var$resolve;

});

var $dfbc8d6948e32077$exports = {};

(parcelRequire("68bIR")).register(new URL("", import.meta.url).toString(), JSON.parse('["7EfW3","index.f77e0bd3.js","arlIS","refresh-icon.009bc1af.png","esk2j","screenshot-icon.5e549a92.png","gd3tJ","undo-icon.b172f9dc.png","c0UAd","redo-icon.691e2ad6.png","52RBs","play-icon.1244da64.png","3xtKt","pause-icon.6262a893.png","gcYp9","binicon.f413c360.png","iWKmc","prev-arrow-white-icon.843aaffe.png","i8sS8","next-arrow-white-icon.78989721.png","jHkxx","help-icon.1cb874a1.png","cCMG3","collapsible-icon.a6e3afbe.png","4Imiq","download-icon.2bc7be26.png","3r5Y9","k_grid_density-formula.9368f611.png","8bZan","atom_properties_shot.51402526.png","1Uit9","BandStructure-icon.59236816.png","kXbjs","GW-Workflow-icon.94691551.png","4VJ9j","MD-Workflow-icon.2ec9a2c9.png","gXX4d","DesignedWorkflow-icon.c0d0b72f.png","gPxXT","SISSOactive-icon.80ed65b9.png","884gj","ControlGenerator-icon.7e7e6fcc.png","aToeu","OutputAnalyzer-icon.9f19e705.png","iXApT","SimpleCalculation-icon.f33bfdcc.png","5lqb8","StructureBuilder-icon.37caf98b.png"]'));


//# sourceMappingURL=index.runtime.d8f7ae04.js.map
